// Mock data for Unstoppable You coaching website

export const heroData = {
  headline: "Become the version of you that you can't ignore",
  subheading: "This isn't self-help. This is self-mastery.",
  ctaText: "Start Your Transformation",
  ctaLink: "https://wa.me/917411750372",
  backgroundImage: "https://images.unsplash.com/photo-1772442125784-bec74803ede9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxjb25maWRlbnQlMjB0cmFuc2Zvcm1hdGlvbnxlbnwwfHx8fDE3NzYyNjE3ODN8MA&ixlib=rb-4.1.0&q=85"
};

export const aboutData = {
  heading: "From Corporate to Conscious",
  story: [
    "I spent years climbing the ladder, ticking boxes, and wondering why success felt empty.",
    "The shift didn't happen overnight. It happened the day I chose myself over comfort. The day I stopped seeking validation and started seeking truth.",
    "Now, I help others do the same. Not through theory, but through transformation. Through deep inner work that creates lasting change.",
    "This isn't about becoming someone new. It's about becoming who you already are — without the fear, without the doubt, without the limits you've accepted as truth."
  ],
  image: "https://customer-assets.emergentagent.com/job_e00c593a-5f41-4154-9704-94e459198325/artifacts/y69znoib_JPEG%20image-409B-A12F-78-0.jpeg"
};

export const servicesData = [
  {
    id: 1,
    title: "1:1 Coaching",
    description: "Deep, personalized transformation work. We don't just set goals — we rebuild your foundation. Identity, beliefs, and emotional mastery.",
    icon: "user"
  },
  {
    id: 2,
    title: "Group Programs & Workshops",
    description: "Collective transformation. Learn alongside others who are ready to rise. High-energy, high-impact sessions that shift your reality.",
    icon: "users"
  },
  {
    id: 3,
    title: "Corporate Workshop",
    description: "More self-aware and emotionally intelligent employees. Stronger ownership and accountability across teams. Improved collaboration and communication. Reduced stress-driven reactions. A culture that supports growth, not just targets.",
    icon: "briefcase"
  }
];

export const resultsData = {
  heading: "What You'll Gain",
  outcomes: [
    {
      id: 1,
      title: "Unshakeable Confidence",
      description: "Not the kind that needs validation. The kind that comes from knowing who you are."
    },
    {
      id: 2,
      title: "Radical Clarity",
      description: "No more second-guessing. You'll know what you want and how to get it."
    },
    {
      id: 3,
      title: "Emotional Strength",
      description: "Feel everything. Control your response to everything. That's real power."
    },
    {
      id: 4,
      title: "Disciplined Action",
      description: "Motivation fades. Discipline stays. You'll build systems that make success inevitable."
    }
  ],
  statement: "You don't become unstoppable by thinking about it. You become unstoppable by doing the work no one else is willing to do."
};

export const ctaData = {
  heading: "You don't need more time. You need a decision.",
  subheading: "The version of you that you dream about is waiting. But she won't wait forever.",
  buttonText: "Contact on WhatsApp",
  bookingLink: "https://wa.me/917411750372"
};

export const footerData = {
  brandName: "Unstoppable You",
  tagline: "Self-mastery. Not self-help.",
  email: "garima@unstoppableyou.in",
  phone: "+91 7411750372",
  socialLinks: [
    {
      platform: "Instagram",
      url: "https://www.instagram.com/unstoppableyoubygarima/",
      icon: "instagram"
    },
    {
      platform: "LinkedIn",
      url: "https://www.linkedin.com/in/garima06",
      icon: "linkedin"
    }
  ],
  copyright: `© ${new Date().getFullYear()} Unstoppable You. All rights reserved.`
};

export const testimonialsData = [
  {
    id: 1,
    quote: "Honestly? I came in a mess. Burnout, self-doubt, the works. I didn't even believe coaching could help me. Three months later, I barely recognize the way I talk to myself. Garima has a way of getting to the root of things without making you feel judged. That inner critic has finally shut up.",
    name: "Tanvi Mehta",
    role: "Marketing Manager, Pune"
  },
  {
    id: 2,
    quote: "I kept self-sabotaging every time something good was about to happen. Garima helped me see exactly why — and more importantly, how to stop. It's like she rewired something in me.",
    name: "Jordan Ellis",
    role: "Freelance Designer, London"
  },
  {
    id: 3,
    quote: "I've done therapy, journaling, retreats — you name it. Working with Garima was different. The work went deeper and moved faster than anything else I've tried. Real transformation, not just surface-level mindset tips.",
    name: "Fatima Al-Rashidi",
    role: "HR Director, Dubai"
  },
  {
    id: 4,
    quote: "I was operating from scarcity in every area of my life without even realizing it. Garima cracked that open in a way I wasn't expecting. My relationship with money, people, and risk has completely shifted.",
    name: "Rohan Nair",
    role: "Startup Founder, Bengaluru"
  },
  {
    id: 5,
    quote: "What got me was how Garima never told me what to do. She asked the right questions until I found my own answers. That's where the real change happened — it came from inside me, not from her.",
    name: "Camille Dubois",
    role: "Teacher turned Entrepreneur, Paris"
  },
  {
    id: 6,
    quote: "I used to think mindset work was soft. I was wrong. Working with Garima was the hardest and most rewarding thing I've done for my career. My numbers improved, yes — but more than that, I actually enjoy showing up now.",
    name: "Kwame Asante",
    role: "Sales Executive, Accra"
  },
  {
    id: 7,
    quote: "Imposter syndrome had me paralyzed for years. After working with Garima, I submitted my research, presented at a conference, and didn't spiral once. That's huge for me.",
    name: "Mei-Ling Zhou",
    role: "PhD Student, Singapore"
  },
  {
    id: 8,
    quote: "Even as someone learning to coach others, I had my own blocks I hadn't faced. The depth of Garima's work surprised me. I'm a better coach today because of it — and a much more grounded human being.",
    name: "Isabela Carvalho",
    role: "Life Coach in Training, São Paulo"
  },
  {
    id: 9,
    quote: "I kept waiting to feel 'ready' before going after what I wanted. Garima showed me that readiness isn't something you wait for. It's something you build. I stopped waiting.",
    name: "Aarav Sharma",
    role: "IT Professional, Hyderabad"
  },
  {
    id: 10,
    quote: "Between the night shifts and the kids, I had completely lost myself. Garima gave me back to me. I can't put a price on that.",
    name: "Nadia Okonkwo",
    role: "Nurse & Mother of two, Lagos"
  }
];
